/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigUpdateResponse extends models.ServiceNowCmdbConfigBaseResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigUpdateResponse>): ServiceNowCmdbConfigUpdateResponse {
        let obj = Object.assign(new ServiceNowCmdbConfigUpdateResponse(), model);
        ServiceNowCmdbConfigUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigUpdateResponse>): ServiceNowCmdbConfigUpdateResponse {
        if (!model) return null;
        return ServiceNowCmdbConfigUpdateResponse.newInstance(<ServiceNowCmdbConfigUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigUpdateResponse) {
        if (!obj) return;

        models.ServiceNowCmdbConfigUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigUpdateResponse): boolean {
        if (models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
